<!-- =========================================================================================
  File Name: UserList.vue
  Description: User List page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>

  <div id="page-user-list" class="ag-grid-container">
    <div class="vx-card">
      <grid-action-bar
          v-on:update:search="searchQuery = $event"
          v-on:update:deleted="showDeleted = $event"
          title="Contacts"
      >
        <vs-dropdown-item v-if="componentAccess.canCreate.access">
          <span
              class="flex items-center"
              @click="$router.push({ name: 'contact.create' })"
          >
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="mr-2" />
            <span>Create Contact</span>
          </span>
        </vs-dropdown-item>
        <vs-dropdown-item :disabled="showDeleted" v-if="componentAccess.canEdit.access">
          <span
              class="flex items-center"
              @click="openCompanyAssign"
          >
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="mr-2" />
            <span>Assign to entity</span>
          </span>
        </vs-dropdown-item>
        <vs-dropdown-item v-if="componentAccess.canEdit.access">
          <span
              class="flex items-center"
              @click="downloadExport"
          >
            <feather-icon icon="DownloadIcon" svgClasses="h-4 w-4" class="mr-2" />
            <span>Download Contact CSV</span>
          </span>
        </vs-dropdown-item>
      </grid-action-bar>

      <!-- AgGrid Table -->
      <t-grid
          :column-defs="columnDefs"
          class="lg"
          :data="data"
          :loading="loading"
          :search="searchQuery"
          :gridOptions="gridOptions"
          @onSelectionChanged="selectionChanged"
          @rowClicked="rowClicked"
          @ready="setGridDefs"
          @update:gridApi="(gridApi) => this.gridApi = gridApi"
      >
      </t-grid>

      <company-assign-modal
          v-model="modals.companyAssign.visible"
          :selected-contacts="selectedContactIds"
          @updated="modalUpdated('companyAssign')"
          @close="closeModal('companyAssign')"
          @cancel="closeModal('companyAssign')"
          @error="modalError"
      />

    </div>
  </div>

</template>

<script>
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import vSelect from 'vue-select'
import api from '@/api';
import companyAssignModal from './UserCompanyAssignModal'
// Cell Renderer
import CellRendererVerified from '../../../components/ag-grid/cell-renderer/CellRendererVerified.vue'
import CellRendererConcat from "../../../components/ag-grid/cell-renderer/CellRendererConcat";
import CellRendererConcatArray from "../../../components/ag-grid/cell-renderer/CellRendererConcatArray";
import TGrid from "@/views/components/ag-grid/TGrid";
import YesNoToggle from "@/views/components/extra-components/YesNoToggle";
import GridActionBar from "@/views/components/extra-components/GridActionBar";
import CanAccessMixin from "@/components/mixins/CanAccessMixin";


export default {
  components: {
    vSelect,
    TGrid,
    companyAssignModal,
    YesNoToggle,
    GridActionBar,

    // Cell Renderer
    CellRendererVerified,
    CellRendererConcat,
    CellRendererConcatArray,
  },
  mixins: [CanAccessMixin],
  data () {
    return {
      searchQuery: '',
      showDeleted: false,

      componentAccess: {
        canCreate: {
          route: 'contact.create',
          access: false,
        },
        canEdit: {
          route: 'contact.edit',
          access: false,
        },
      },

      selectedContactIds: [],

      modals: {
        companyAssign: {
          visible: false
        },
      },

      loading: false,
      data: [],

      gridApi: null,
      gridOptions: {},
      columnDefs: [
        {
          headerName: 'Entity Name',
          field: 'CompanyName',
          filter: 'agTextColumnFilter',
          width: 315,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true,
          cellRenderer: 'CellRendererConcat',
          cellRendererParams(params) {
            return {
              valueFields: ['CompanyName', 'CompanyCode'],
              join: ' - '
            }
          },
        },
        {
          headerName: 'Title',
          field: 'Title',
          filter: 'agTextColumnFilter',
          width: 150,
        },
        {
          headerName: 'First Name',
          field: 'FirstName',
          filter: 'agTextColumnFilter',
          width: 200,
          sort: 'asc',
        },
        {
          headerName: 'Last Name',
          field: 'LastName',
          filter: 'agTextColumnFilter',
          width: 200,
        },
        {
          headerName: 'Job Title',
          field: 'JobTitle',
          filter: 'agTextColumnFilter',
          width: 225,
        },
        {
          headerName: 'Role(s)',
          field: 'Roles',
          filter: 'agTextColumnFilter',
          width: 225,
          cellRenderer: 'CellRendererConcatArray',
          cellRendererParams(params) {
            return {
              valueField: 'Roles'
            }
          },
        },
        {
          headerName: 'Username',
          field: 'EmailAddress',
          filter: 'agTextColumnFilter',
          width: 225
        },
        {
          headerName: 'Is User',
          field: 'IsUser',
          filter: true,
          width: 200,
          cellRenderer: 'CellRendererVerified',
          cellClass: 'text-center',
        },
        {
          headerName: 'Is Active',
          field: 'IsEnabled',
          filter: true,
          width: 200,
          cellRenderer: 'CellRendererVerified',
          cellClass: 'text-center',
        },
        {
          headerName: 'Main',
          field: 'Main',
          filter: true,
          width: 200,
          cellRenderer: 'CellRendererVerified',
          cellClass: 'text-center',
        },
      ],

      // Cell Renderer Components
      components: {
        CellRendererVerified
      }
    }
  },
  watch: {
    showDeleted(value) {
      this.list({IsDeleted: value | 0});
    }
  },
  computed: {},
  methods: {
    openCompanyAssign() {
        if (this.selectedContactIds.length === 0) {
          this.modalError('No contacts selected')
          return;
        }

        this.openModal('companyAssign');
    },
    selectionChanged() {
      if (this.gridApi) {
        const selectedContacts = this.gridApi.getSelectedNodes();
        this.selectedContactIds = selectedContacts.map(node => node.data.id);
      }
    },
    resetSelection() {
      this.selectedContactIds = [];
    },
    modalError(errorMessage) {
      this.$vs.notify({
        color: 'danger',
        title: 'Error occurred',
        text: errorMessage,
        position: 'top-right'
      })
    },
    modalUpdated(modalName) {
      this.closeModal(modalName);
      this.success('The selected contacts were successfully updated')
      this.loadList();
    },
    success(successMessage) {
      this.$vs.notify({
        color: 'success',
        title: 'Contacts updated',
        text: successMessage,
        position: 'top-right'
      })
    },
    openModal(modalName) {
      this.modals[modalName].visible = true;
    },
    closeModal(modalName) {
      this.modals[modalName].visible = false;
    },
    setGridDefs() {
      // if (!this.gridApi) {
      //   this.gridApi = this.gridOptions.api;
      // }
    },
    rowClicked(data) {
      this.$root.$router.push({ path: `/contacts/${data.data.id}` })
    },
    async list(params = {}) {
      this.resetSelection();
      try {
        this.loading = true;
        const { data } = await this.$api.users.all({ params });
        this.data = data.data;
        this.gridApi.paginationGoToFirstPage();
      } catch (e) {
        console.log(e);
      } finally {
        this.loading = false;
      }
    },
    loadList () {
      this.list({IsDeleted: 0});
    },
    async downloadExport() {
      const response = await api.get('/users/download-csv/');

      const blob = new Blob([response.data]);
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.setAttribute("download", "contacts.csv");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
  },
  mounted () {
    this.loadList();
  },
}

</script>

<style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
[col-id="IsUser"],
[col-id="IsEnabled"] {
  .ag-header-cell-label {
    text-align: center;

    .ag-header-cell-text {
      flex: 1;
    }
  }
}
</style>
